/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EligibilityRequestServiceTypeCodes
 */
export interface EligibilityRequestServiceTypeCodes {
    /**
     * 
     * @type {Array<string>}
     * @memberof EligibilityRequestServiceTypeCodes
     */
    serviceTypeCode?: Array<string>;
}

/**
 * Check if a given object implements the EligibilityRequestServiceTypeCodes interface.
 */
export function instanceOfEligibilityRequestServiceTypeCodes(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EligibilityRequestServiceTypeCodesFromJSON(json: any): EligibilityRequestServiceTypeCodes {
    return EligibilityRequestServiceTypeCodesFromJSONTyped(json, false);
}

export function EligibilityRequestServiceTypeCodesFromJSONTyped(json: any, ignoreDiscriminator: boolean): EligibilityRequestServiceTypeCodes {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'serviceTypeCode': !exists(json, 'serviceTypeCode') ? undefined : json['serviceTypeCode'],
    };
}

export function EligibilityRequestServiceTypeCodesToJSON(value?: EligibilityRequestServiceTypeCodes | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'serviceTypeCode': value.serviceTypeCode,
    };
}

